module.exports = {

    init: function () {
        let mainNavEl = document.getElementById("main-nav");
        let navSearchAreaContainer = document.getElementById("nav-search-area-container");
        let timeoutId_Search = null;
        function openSearch() {

            navSearchAreaContainer.setAttribute("aria-hidden", "false");
            navSearchAreaContainer.style.display = "block";

            if (timeoutId_Search) {
                clearTimeout(timeoutId_Search);
            }

            // delay so that animation works
            timeoutId_Search = setTimeout(function () {
                mainNavEl.classList.add("search-open");
                timeoutId_Search = null;
            }, 10);
        }

        function closeSearch() {
            if (mainNavEl.classList.contains("search-open")) {
                mainNavEl.classList.remove("search-open");
                navSearchAreaContainer.setAttribute("aria-hidden", "true");
                let inputBox = document.querySelector("#main-search-box input[type='text']");
                inputBox.value = "";

                document.activeElement.blur();

                if (document.activeElement)
                    document.activeElement.blur();

                if (timeoutId_Search) {
                    clearTimeout(timeoutId_Search);
                }

                timeoutId_Search = setTimeout(function () {
                    navSearchAreaContainer.style.display = "none";
                }, 350);
            }
        }


        let searchButtonEl = document.getElementById("search-button");

        if (searchButtonEl) {

            navSearchAreaContainer.style.display = "none";
            navSearchAreaContainer.setAttribute("aria-hidden", "true");

            function toggleSearch(evt) {
                if (evt) {
                    evt.preventDefault();
                }

                let inputBox = document.querySelector("#main-search-box input[type='text']");

                if (mainNavEl.classList.contains("search-open")) {
                    closeSearch();
                } else {
                    openSearch();

                    var ua = window.navigator.userAgent;
                    var iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);

                    if (iOS) {
                        inputBox.focus();
                    } else {
                        setTimeout(() => {
                            inputBox.focus();
                        }, 400);
                    }

                }
            }

            searchButtonEl.addEventListener("click", toggleSearch);

            let searchCloseEl = document.getElementById("search-close-button");
            searchCloseEl.addEventListener("click", toggleSearch);
        }

        $('.dropdown').on('show.bs.dropdown', function () {
            document.body.classList.add('showing-dropdown');

        })
        $('.dropdown').on('hide.bs.dropdown', function () {
            document.body.classList.remove('showing-dropdown');
        })

        $('#navbarNav').on('show.bs.collapse', function () {
            document.body.classList.add('showing-nav');
        })

        $('#navbarNav').on('hide.bs.collapse', function () {
            document.body.classList.remove('showing-nav');
        })

    }
};